export function getUserTimeInfo(){
	const date = new Date();
	const offsetInMinutes = date.getTimezoneOffset();
	const offsetInHours = -offsetInMinutes / 60;
	const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	return `UTC${offsetInHours >= 0 ? '+' : ''}${offsetInHours}`;
};